import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-95';
  const variants = {
    primary: 'bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 shadow-md hover:shadow-lg',
    secondary: 'bg-slate-100 text-slate-900 hover:bg-slate-200 shadow-sm',
    outline: 'border-2 border-slate-300 bg-white hover:bg-slate-50 text-slate-700 hover:border-slate-400 shadow-sm',
    ghost: 'hover:bg-slate-100 text-slate-700'
  };
  const sizes = {
    sm: 'h-9 px-3 text-xs sm:text-sm',
    md: 'h-10 sm:h-11 px-4 sm:px-6 text-sm sm:text-base',
    lg: 'h-12 sm:h-14 px-6 sm:px-8 text-base sm:text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-647">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-648" />}
      {children}
    </button>;
}